import React, { useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Button, Form, Container, Row, Col } from "react-bootstrap";
import { useState } from "react";

// css
import styles from "../../../layout/Auth/Auth.module.scss";
import OTPInput from "react-otp-input";
import OTPTimer from "components/shared/OTPTimer";
import { otpShema } from "utils/validation/validationHelpers";
import useFieldValidation from "hooks/useFieldValidation";
import { useForgotPasswordMutation } from "store/services/auth";

const Otp = () => {
  const [forgotPasswordSubmit, { isLoading }] = useForgotPasswordMutation();
  const navigate = useNavigate();
  const { state } = useLocation();
  const [otp, setOtp] = useState("");
  const fieldError = useFieldValidation(otp, otpShema);

  useEffect(() => {
    if(!state?.username) {
      navigate("/")
    }
  }, [state]);

  const handleResendOtp = async () => {
    try {
      await forgotPasswordSubmit({
        username: state?.username
      }).unwrap();
    } catch(err) {
      console.error("Resend Otp failed:", err);
    }
  }

  const handleNavigateResetPassword = async () => {
    if(fieldError) {
      return;
    }
    navigate("/reset-password", { state: { otp, username: state?.username } });
  }

  return (
    <>
      <div className="formInner position-relative px-lg-3">
        <div className="w-100 inner">
          <div className="top py-2 text-center">
            <h4 className="m-0 fw-bold py-1">Enter OTP</h4>
            <p className="m-0 text-muted fw-sbold py-1">
              OTP sent to your email address.
            </p>
          </div>
          <Form className={`${styles.form} pt-lg-4 pt-2`}>
            <Row className="justify-content-center">
              <Col lg="12">
                <div className="otpWrp">
                  <OTPInput
                    value={otp}
                    onChange={setOtp}
                    numInputs={6}
                    renderInput={(props) => <input {...props} />}
                  />
                </div>
                {fieldError && (
                  <p className="error">{fieldError}</p>
                )}
              </Col>
              <Col lg="12" className="justify-content-end text-end">
                <OTPTimer
                  onResend={handleResendOtp}
                  timerDuration={60}
                />
              </Col>
              <Col lg="8" className="my-2">
                <div className={`${styles.btnWrpper} pt-4 btnWrpper`}>
                  <Button
                    onClick={handleNavigateResetPassword}
                    className="d-flex align-items-center justify-content-center w-100 commonBtn"
                  >
                    Submit
                  </Button>
                </div>
              </Col>
            </Row>
          </Form>
        </div>
      </div>
    </>
  );
};
export default Otp;
